export default "__VITE_ASSET__DVgqtcaL__"